import React, { useState } from 'react'
import { Blacked, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Input, Select, Table, message } from 'antd'
import API from 'utils/api';
import { useToken } from 'app/hooks';
import {useIsMobile} from "../IsMobile";

export const TotalStatusChange = ({ selectTable, setSelectTable, setIsTotalStatus, dbList, mutate, statusList }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const filterList = dbList?.filter(it => selectTable?.includes(it.id))
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');
  const [status, setStatus] = useState('');

  const clickSubmit = () => {
    const shouldEdit = window.confirm(`상태: ${statusList?.find(it => it.id == status)?.name} \n변경하실 상태가 맞습니까?`);
    if(shouldEdit) {
      if(status == '') {
        message.error('상태를 선택하지 않았습니다.')
      } else {
        API.put('/users', token + '', {
          datas: {
            ids: selectTable,
            statusId: status
          }
        })
        .then((res: any) => {
          if (res.result.success) {
            message.success('변경되었습니다');
            mutate();
            setIsTotalStatus(false);
            setSelectTable([]);
          }
        })
        .catch((err: any) => {})
      }
    }
  }

  const mobileColumns = [
    {
      dataIndex: '',
      title: '일괄상태',
      render: (value, data) => {
        return (
          <>
            <div className='name'
                 style={{display: 'flex', justifyContent: 'flex-start' , color: '#437EFF', textDecoration: 'underline', cursor: 'pointer', backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color}}>
              <p style={{marginRight: 5, fontWeight: 'bold'}}>이름: </p> {data?.name || '-'}
            </div>
            <div className='tel' style={{display: 'flex', justifyContent: 'flex-start' ,backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color}}>
              <p style={{marginRight: 5, fontWeight: 'bold'}}>연락처: </p> {data?.tel || '-'}
            </div>
            <div className='path' style={{display: 'flex', justifyContent: 'flex-start' ,backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color}}>
              <p style={{marginRight: 5, fontWeight: 'bold'}}>방문경로: </p> {data?.accessPathName || '-'}
            </div>
            <div className='status' style={{display: 'flex', justifyContent: 'flex-start',alignItems: "center", textAlign: 'center' ,backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color,}}>
              <p style={{marginRight: 5, fontWeight: 'bold'}}>상태:</p>
              <Select value={status} onChange={(e) => setStatus(e)} style={{fontFamily: 'Pretendard', minWidth: 100, height: 25}}>
                {statusList?.map(it => (
                  <option value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
                ))}
              </Select>
            </div>
            <div className='manager' style={{display: 'flex', justifyContent: 'flex-start' ,backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color}}>
              <p style={{marginRight: 5, fontWeight: 'bold'}}>담당자: </p>  {data?.responsibilityName || '-'}
            </div>
            <div className='date' style={{display: 'flex', justifyContent: 'flex-start' ,backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color}}>
              <p style={{marginRight: 5, fontWeight: 'bold'}}>배정일: </p>{data?.assignedAt || '-'}
            </div>
            <div className='date' style={{display: 'flex', justifyContent: 'flex-start' ,backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color}}>
              <p style={{marginRight: 5, fontWeight: 'bold'}}>등록일: </p> {data?.createdAt || '-'}
            </div>
            <div className='memo' style={{display: 'flex', justifyContent: 'flex-start' ,backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color}}>
              <p style={{marginRight: 5, fontWeight: 'bold'}}>메모: </p> {data?.memo || '-'}
            </div>



          </>

        )
      }
    },
  ]

  const columns = [
    {
      dataIndex: '',
      title: '이름',
      render: (value, data) => {
        return (
          <div className='name' 
            style={{color: '#437EFF', textDecoration: 'underline', cursor: 'pointer', backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color, padding: 10}}>
            {data?.name}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '연락처',
      render: (value, data) => {
        return (
          <div className='tel' style={{backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color, padding: 10}}>
            {data?.tel}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '방문경로',
      render: (value, data) => {
        return (
          <div className='path' style={{backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color, padding: 10}}>
            {data?.accessPathName}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '상태',
      render: (value, data) => {
        return (
          <div className='status' style={{textAlign: 'center',backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color, padding: 5}}>
            <Select value={status} onChange={(e) => setStatus(e)} style={{fontFamily: 'Pretendard', minWidth: 100}}>
              {statusList?.map(it => (
                <option value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
              ))}
            </Select>
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '담당자',
      render: (value, data) => {
        return (
          <div className='manager' style={{backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color, padding: 10}}>
            {data?.responsibilityName}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '배정일',
      render: (value, data) => {
        return (
          <div className='date' style={{backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color, padding: 10}}>
            {data?.assignedAt}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '등록일',
      render: (value, data) => {
        return (
          <div className='date' style={{backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color, padding: 10}}>
            {data?.createdAt}
          </div>
        )
      }
    },
    {
      dataIndex: '',
      title: '메모',
      render: (value, data) => {
        return (
          <div className='memo' style={{backgroundColor: statusList?.find(it => it.id == data?.statusId)?.color, padding: 10, height:43}}>
            {data?.memo}
          </div>
        )
      }
    },
  ];
  
  return (
    <>
      <Blacked onClick={() => setIsTotalStatus(false)} />

      {IsMobile?
        <ModalWrapper IsMobile={IsMobile}>
          <ModalHeader>
            <Icon onClick={() => setIsTotalStatus(false)}><FaChevronLeft /></Icon>
            <ModalTitle>일괄상태변경</ModalTitle>
            <ModalSubmit onClick={clickSubmit}>저장</ModalSubmit>
          </ModalHeader>
          <ModalContent>
            <Table dataSource={filterList} columns={mobileColumns} pagination={false} bordered={true} />
          </ModalContent>
        </ModalWrapper>
        :
        <ModalWrapper style={{width: '1524px'}}>
          <ModalHeader>
            <Icon onClick={() => setIsTotalStatus(false)}><FaChevronLeft /></Icon>
            <ModalTitle>일괄상태변경</ModalTitle>
            <ModalSubmit onClick={clickSubmit}>저장</ModalSubmit>
          </ModalHeader>
          <ModalContent>
            <Table className='DBTable' dataSource={filterList} columns={columns} pagination={false} />
          </ModalContent>
        </ModalWrapper>
      }

    </>
  )
}

export default React.memo(TotalStatusChange);